// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"47f5277a","225":"f3e4e21f","470":"04a980af","603":"fe99f300"}[chunkId] + ".chunk.css";
};